module.exports = __webpack_public_path__ + "img/icon-14.8a7be5e0.svg";